import {EntityModel} from '../../../core/model/entity.model';
import {LocalDate} from '@js-joda/core';

export class ConfigurationParameters extends EntityModel {
  public code?: string;

  public value?: number;

  public effectiveStart?: LocalDate;

  public effectiveEnd?: LocalDate;
}
